module.exports = __webpack_public_path__ + "static/img/591617348766.b9f8fbec.jpg";